module.exports = __webpack_public_path__ + "static/media/sign.cbcf0634.svg";